import React from "react";

function ResetIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#fff"
        d="M24 11.583c0 6.414-5.224 11.586-11.586 11.586-2.535 0-4.966-.776-6.983-2.276-.724-.569-.88-1.603-.31-2.327.569-.724 1.603-.88 2.327-.362a8.19 8.19 0 004.966 1.655 8.267 8.267 0 008.276-8.276c0-4.552-3.725-8.224-8.276-8.224-1.966 0-3.776.672-5.276 1.862l2.38 2.327c.879.88.206 2.431-1.035 2.431h-7.5C.413 9.98 0 9.514 0 8.945v-7.5C0 .152 1.5-.469 2.38.41l2.43 2.483A11.534 11.534 0 0112.414.048C18.776.048 24 5.221 24 11.583z"
      ></path>
    </svg>
  );
}

export default React.memo(ResetIcon);
